import axios from 'axios';

export default {
  getStructure: () => axios.get('/api/v1/view/structure'),
  getFullStructure: () => axios.get('/api/v1/view/structure?fullStructure=true'),
  getFullStructureWithoutFile: () => axios.get('/api/v1/view/structure?fullStructure=true&withoutFile=true'),
  createStructure: (params) => axios.post('/api/v1/view/structure', params),
  updateStructure: ({ params, id }) => axios.put(`/api/v1/view/structure/${id}`, params),
  deleteStructure: (id) => axios.delete(`/api/v1/view/structure/${id}`),
  changeStructureOrder: (params) => axios.post('/api/v1/view/structure-order', params),
};
